import React, { useState } from "react";

const PackagesHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [hovered, setHovered] = useState(null);

  return (
    <header className="header">
      <div className="container">

        {/* Logo */}
        <div className="logoSection">
          <a href="/">
            <img
              src="/images/logo.png"
              alt="Logo"
              className="logo"
            />
          </a>
        </div>

        {/* Hamburger */}
        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Navigation */}
        <nav className={`navSection ${menuOpen ? "open" : ""}`}>

          {/* ABOUT */}
          <a
            href="/about"
            onMouseEnter={() => setHovered("about")}
            onMouseLeave={() => setHovered(null)}
            onClick={() => setMenuOpen(false)}
          >
            <img
              src={
                hovered === "about"
                  ? "/images/about-hover.png"
                  : "/images/about.png"
              }
              alt="About Us"
            />
            About Us
          </a>

          {/* PACKAGES */}
          <a
            href="/packages"
            onMouseEnter={() => setHovered("packages")}
            onMouseLeave={() => setHovered(null)}
            onClick={() => setMenuOpen(false)}
          >
            <img
              src={
                hovered === "packages"
                  ? "/images/package-hover.png"
                  : "/images/package.png"
              }
              alt="Holiday Packages"
            />
            Holiday Packages
          </a>

          {/* CONTACT */}
          <a
            href="/contact"
            onMouseEnter={() => setHovered("contact")}
            onMouseLeave={() => setHovered(null)}
            onClick={() => setMenuOpen(false)}
          >
            <img
              src={
                hovered === "contact"
                  ? "/images/customer-service-hover.png"
                  : "/images/customer-service.png"
              }
              alt="Contact Us"
            />
            Contact Us
          </a>

          {/* MOBILE ACCOUNT */}
          <a
            href="/profile"
            className="mobileAccount"
            onClick={() => setMenuOpen(false)}
          >
            My Account
          </a>
        </nav>

        {/* Desktop Account Button */}
        <div className="accountSection">
          <a href="/profile">
            <button className="accountBtn">
              My Account
            </button>
          </a>
        </div>

      </div>
    </header>
  );
};

export default PackagesHeader;